import { BUS_STOP_THRESHOLD } from '../../helpers/TxpConstants';
import createCardsNoBusStop from './createCardsNoBusStop';
import createCardsWithBusStop from './createCardsWithBusStop';
import createEntitiesPrimaryHash from './createEntitiesPrimaryHash';
import CardItem from '../../schema/viewSchema/CardItem';
import CardRole from '../../schema/innerSchema/CardRole';
import TxpImages from '../../schema/configSchema/TxpImages';
import TxpObject from '../../schema/TxpObject';
import TxpStrings from '../../schema/configSchema/TxpStrings';

export default function populateViewCards(
    txpParsedObject: TxpObject,
    calendarEventIds: any[],
    showEnhancedLocation: boolean,
    txpStrings: TxpStrings,
    txpImages?: TxpImages,
    cardRole?: CardRole
): { cardItems: CardItem[]; isBusStopEnabled: boolean } {
    if (txpParsedObject) {
        let cardItems: CardItem[] = [];
        let activities = txpParsedObject.txpActivities;
        let entities = txpParsedObject.txpEntities;
        let entitiesPrimaryHash = createEntitiesPrimaryHash(activities);
        let numberOfPrimaryCards = Object.values(entitiesPrimaryHash).reduce((total, num) => {
            return total + num;
        });
        let isBusStopEnabled = numberOfPrimaryCards > BUS_STOP_THRESHOLD;

        if (activities && entities && entitiesPrimaryHash) {
            cardItems = isBusStopEnabled
                ? createCardsWithBusStop(
                      activities,
                      entities,
                      showEnhancedLocation,
                      txpStrings,
                      txpImages,
                      calendarEventIds
                  )
                : createCardsNoBusStop(
                      activities,
                      entities,
                      entitiesPrimaryHash,
                      showEnhancedLocation,
                      txpStrings,
                      txpImages,
                      calendarEventIds,
                      cardRole
                  );

            return {
                cardItems: cardItems,
                isBusStopEnabled: isBusStopEnabled,
            };
        }
    }
    return null;
}
